export default __webpack_public_path__ + "53b3ccc585a7ee26b57228c460867602.png";